import { IContent } from "@vmosolutions/oc-interfaces";
import { Alert, styled } from "@mui/material";
import { useFileContents } from "src/pages/contentViewers/useFileContents";
import { ViewerShell } from "src/pages/contentViewers/ViewerShell";

interface ITextViewerProps {
  windowProps: {
    file: IContent;
  };
}

const TextContent = styled("pre")(({ theme }) => ({
  flex: 1,
  minHeight: 0,
  overflow: "auto",
  margin: 0,
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.default,
  color: theme.palette.text.primary,
  fontFamily: "monospace",
  fontSize: "0.85em",
  lineHeight: 1.5,
  whiteSpace: "pre-wrap",
  wordBreak: "break-word",
}));

export function TextViewerWindow(props: ITextViewerProps): JSX.Element {
  const { file } = props.windowProps;
  const { data: text, loading, error } = useFileContents(file, "text");

  return (
    <ViewerShell file={file} loading={loading} error={error}>
      {text !== null &&
        (text.trim() ? (
          <TextContent>{text}</TextContent>
        ) : (
          <Alert severity="info" variant="filled" sx={{ m: 1 }}>
            This file is empty.
          </Alert>
        ))}
    </ViewerShell>
  );
}
